module.exports = __webpack_public_path__ + "static/media/SeeYouAtStoreImage.da8e0bf3.svg";